export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9382.96aa7539.jpg";